'use client';
import type { ReactNode } from 'react';

import { atom } from 'jotai';

import type { ModalProps } from '../Entities/Modal.entity';

const modalInitialData = {
  header: null,
  content: null,
  modalAction: null,
  children: null,
  centered: true,
  onClose: () => null,
  onOpen: () => null,
};
export const modalDataAtom = atom<ModalProps>(modalInitialData);

export const isModalOpenAtom = atom(false);

export const closeModalAtom = atom(null, (get, set, shouldReset?: boolean) => {
  const modalData = get(modalDataAtom);
  modalData.onClose?.();

  set(isModalOpenAtom, false);

  if (shouldReset) set(modalDataAtom, modalInitialData);
});

export const resetModalAtom = atom(null, (_get, set) => {
  set(modalDataAtom, modalInitialData);
  set(isModalOpenAtom, false);
});

export const openModalAtom = atom(null, (_get, set, content: ReactNode, modalProps: ModalProps) => {
  set(modalDataAtom, { onClose: () => null, content, ...modalProps });
  set(isModalOpenAtom, true);

  modalProps.onOpen?.();
});
